<template>
  <div class="columns is-multiline my-0">
    <form-field-input
      label="Bedrooms"
      v-model="form.bedrooms"
      :validation-errors="validationErrors.bedrooms"
      :help-text="`Property Data: ${formatValue(formData.bedrooms_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="House Size"
      v-model="form.house_size"
      :validation-errors="validationErrors.house_size"
      :help-text="`Property Data: ${formatValue(formData.house_size_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Bathrooms"
      v-model="form.bathrooms"
      :validation-errors="validationErrors.bathrooms"
      :help-text="`Property Data: ${formatValue(formData.bathrooms_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Partial Bathrooms"
      v-model="form.partial_bathrooms"
      :validation-errors="validationErrors.partial_bathrooms"
      :help-text="`Property Data: ${formatValue(formData.partial_bathrooms_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Year Built"
      v-model="form.year_built"
      :validation-errors="validationErrors.year_built"
      :help-text="`Property Data: ${formatValue(formData.year_built_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Lot Size"
      v-model="form.lot_size"
      :validation-errors="validationErrors.lot_size"
      :help-text="`Property Data: ${formatValue(formData.lot_size_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Parking Type"
      v-model="form.parking_type"
      :validation-errors="validationErrors.parking_type"
      :help-text="`Property Data: ${formatValue(formData.parking_type_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Stories"
      v-model="form.stories"
      :validation-errors="validationErrors.stories"
      :help-text="`Property Data: ${formatValue(formData.stories_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-select
      label="Pool"
      v-model="form.pool"
      :validation-errors="validationErrors.pool"
      :help-text="`Property Data: ${formatBoolean(formData.pool_api)}`"
      class="column is-6 mb-200"
    >
      <option :value="1">Yes</option>
      <option :value="0">No</option>
    </form-field-select>

    <form-field-input
      label="Fireplaces (count)"
      v-model="form.fireplaces"
      :validation-errors="validationErrors.fireplaces"
      :help-text="`Property Data: ${formatValue(formData.fireplaces_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Heating Type"
      v-model="form.heating_type"
      :validation-errors="validationErrors.heating_type"
      :help-text="`Property Data: ${formatValue(formData.heating_type_api)}`"
      class="column is-6 mb-200"
    ></form-field-input>

    <form-field-input
      label="Cooling Type"
      v-model="form.cooling_type"
      :validation-errors="validationErrors.cooling_type"
      :help-text="`Property Data: ${formatValue(formData.cooling_type_api)}`"
      class="column is-6"
    ></form-field-input>

    <form-field-input
      label="Basement Size"
      v-model="form.basement_size"
      :validation-errors="validationErrors.basement_size"
      :help-text="`Property Data: ${formatValue(formData.basement_size_api)}`"
      class="column is-6"
    ></form-field-input>

    <form-field-input
      label="Construction Type"
      v-model="form.construction_type"
      :validation-errors="validationErrors.construction_type"
      :help-text="`Property Data: ${formatValue(formData.construction_type_api)}`"
      class="column is-6"
    ></form-field-input>

    <form-field-input
      label="Architecture Type"
      v-model="form.architecture_type"
      :validation-errors="validationErrors.architecture_type"
      :help-text="`Property Data: ${formatValue(formData.architecture_type_api)}`"
      class="column is-6"
    ></form-field-input>

    <form-field-select
      label="Is Mobile Home?"
      v-model="form.mobile_home"
      :validation-errors="validationErrors.mobile_home"
      :help-text="`Property Data: ${formatBoolean(formData.mobile_home_api)}`"
      class="column is-6"
    >
      <option :value="1">Yes</option>
      <option :value="0">No</option>
    </form-field-select>

    <form-field-select
      label="Is in Flood Zone?"
      v-model="form.flood_zone"
      :validation-errors="validationErrors.flood_zone"
      :help-text="`Property Data: ${formatBoolean(formData.flood_zone_api)}`"
      class="column is-6"
    >
      <option :value="1">Yes</option>
      <option :value="0">No</option>
    </form-field-select>

    <form-field-textarea
      label="Amenities"
      v-model="form.amenities"
      :validation-errors="validationErrors.amenities"
      :help-text="`Property Data: ${formatValue(formData.amenities)}`"
      class="column is-12"
    ></form-field-textarea>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import utils from "../services/utils";

export default {
  name: "PropertyDetailsForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        latitude: '',
        longitude: '',
        bedrooms: '',
        bathrooms: '',
        house_size: '',
        basement_size: '',
        lot_size: '',
        year_built: '',
        subdivision: '',
        stories: '',
        parking_type: '',
        cooling_type: '',
        heating_type: '',
        construction_type: '',
        architecture_type: '',
        amenities: '',
        market_value: '',
        assessed_value: '',
        partial_bathrooms: '',
        pool: '',
        fireplaces: '',
        mobile_home: '',
        flood_zone: '',
      },
    }
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    formatValue(value) {
      if (!value) return '--'
      return value;
    },
    formatBoolean(value) {
      if (value === null || value === undefined) return '--'
      return value ? 'Yes' : 'No';
    },
    update() {
      return this.$api.properties.updatePropertyInfo(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Property was updated',
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
